<template>
  <div class="footer-player-artist-image__container">
    <div class="footer-player-artist-image__container-inside">
      <div v-if="$store.getters.musicPlayerModuleGetIsPlaying === false"
           class="footer-player-artist-image__image"
           :class="{'--disabled': !title}"
           style="background-image: url(/static/player/img_playmusic-grey.png);"
           @click="$emit('clickMethod')">
      </div>
      <div v-if="$store.getters.musicPlayerModuleGetIsPlaying && !artistImage" class="footer-player-artist-image__image"
           :class="{'--disabled': !title}"
           style="background-image: url(/static/player/img_playmusic-grey.gif);"
           @click="$emit('clickMethod')">
      </div>
      <img v-if="$store.getters.musicPlayerModuleGetIsPlaying && artistImage" class="footer-player-artist-image__image"
           :src="artistImage"
           @click="$emit('clickMethod')">
    </div>
    <v-icon v-if="title" class="footer-player-artist-image__hover-icon">zoom_out_map</v-icon>
  </div>
</template>
<script>
export default {
  name: 'FooterPlayerArtistImage',
  props: {
    title: String,
    artistImage: String
  }
}
</script>
<style lang="scss" scoped>
.footer-player-artist-image__container-inside {
  position: relative;
}
.footer-player-artist-image__hover-icon {
  display: none;
  position: absolute;
  top: 0;
  height: 72px;
  width: 72px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff !important;
  pointer-events: none;
  font-size: 72px;
}
.footer-player-artist-image__hover-icon:after {
  position: absolute;
  width: 0;
  height: 0;
  left: 0;
  pointer-events: none;
  content: " ";
}
.footer-player-artist-image__container-inside:hover + .footer-player-artist-image__hover-icon {
  display: block;
}
.footer-player-artist-image__image {
  flex-shrink: 0;
  position: relative;
  height: 72px;
  width: 72px;
  cursor: pointer;
  background-size: cover;
  background-color: rgb(100, 100, 100);
  &.--disabled {
   cursor: initial;
   pointer-events: none;
 }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/FooterPLayerArtistImage.vue